import React, { useState, useEffect } from 'react';
import { Save, FileText } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { Textarea } from '../ui/textarea';
import axiosInstance from '../../api/axios';
import { toast } from 'sonner';

const LegalPagesManager = () => {
  const [legalPages, setLegalPages] = useState({
    impressum: '',
    agb: '',
    widerruf: ''
  });
  const [activeLegalTab, setActiveLegalTab] = useState('impressum');
  const [savingLegal, setSavingLegal] = useState(false);

  useEffect(() => {
    loadLegalPages();
  }, []);

  const loadLegalPages = async () => {
    try {
      const response = await axiosInstance.get('/legal-pages');
      if (response.data) {
        setLegalPages(response.data);
      }
    } catch (error) {
      console.error('Error loading legal pages:', error);
    }
  };

  const saveLegalPage = async () => {
    setSavingLegal(true);
    try {
      await axiosInstance.post('/legal-pages', legalPages);
      toast.success('Rechtliche Seite gespeichert!');
    } catch (error) {
      console.error('Error saving legal page:', error);
      toast.error('Fehler beim Speichern');
    } finally {
      setSavingLegal(false);
    }
  };

  const getLegalPageTitle = (type) => {
    const titles = {
      impressum: 'Impressum',
      agb: 'AGB',
      widerruf: 'Widerrufsbelehrung'
    };
    return titles[type] || type;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Rechtliche Seiten
        </CardTitle>
        <p className="text-sm text-gray-600">
          Verwalten Sie Impressum, AGB und Widerrufsbelehrung
        </p>
      </CardHeader>
      <CardContent>
        <Tabs value={activeLegalTab} onValueChange={setActiveLegalTab}>
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="impressum">Impressum</TabsTrigger>
            <TabsTrigger value="agb">AGB</TabsTrigger>
            <TabsTrigger value="widerruf">Widerruf</TabsTrigger>
          </TabsList>

          {['impressum', 'agb', 'widerruf'].map((type) => (
            <TabsContent key={type} value={type} className="space-y-4">
              <div>
                <label className="text-sm font-medium mb-2 block">
                  {getLegalPageTitle(type)}
                </label>
                <Textarea
                  value={legalPages[type]}
                  onChange={(e) => setLegalPages({ ...legalPages, [type]: e.target.value })}
                  placeholder={`Geben Sie hier Ihren ${getLegalPageTitle(type)}-Text ein...`}
                  rows={15}
                  className="font-mono text-sm"
                />
                <p className="text-xs text-gray-500 mt-2">
                  Markdown wird unterstützt. Verwenden Sie ## für Überschriften, ** für Fettdruck, etc.
                </p>
              </div>

              <Button
                onClick={saveLegalPage}
                disabled={savingLegal}
                className="w-full"
              >
                <Save className="h-4 w-4 mr-2" />
                {savingLegal ? 'Speichern...' : `${getLegalPageTitle(type)} Speichern`}
              </Button>
            </TabsContent>
          ))}
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default LegalPagesManager;
